/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "api": {
            "nested": {
              "v1": {
                "nested": {
                  "settlement": {
                    "nested": {
                      "models": {
                        "nested": {
                          "Status": {
                            "values": {
                              "S_DO_NOT_USE": 0,
                              "INITIALIZED": 1,
                              "PENDING": 2,
                              "SENT": 3,
                              "SUCCEEDED": 4,
                              "FAILED": 5,
                              "CANCELLED": 6
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.api?.nested?.v1?.nested?.settlement?.nested?.models?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * The status of the settlement
 *
 * SOURCE Status @ squareup/capital/api/v1/settlement/models.proto at 40:1
 */
export const Status = $root.lookupEnum('squareup.capital.api.v1.settlement.models.Status').values;